module.exports = __webpack_public_path__ + "img/1161769205d5b61ae9e2c61e500ca5b0.png";